export default __webpack_public_path__ + "static/media/clear-backpack.aa4c8421.png";